import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';

@Component({
  selector: 'app-scroll-top',
  templateUrl: './scroll-top.component.html',
  styleUrls: ['./scroll-top.component.less']
})
export class ScrollTopComponent implements OnInit {
  @ViewChild('panelElRef', { static: true }) panelElRef: ElementRef<HTMLElement>;
  @HostListener('window:scroll') onScroll(e: Event): void {
    this.manageScrollPosition(e);
  }

  constructor( ) { }

  ngOnInit() {  }

  ngAfterContentInit() {
    if (this.panelElRef && this.panelElRef.nativeElement) { 
      this.panelElRef.nativeElement.style.visibility = 'hidden';
    }
  }

  manageScrollPosition(e: Event) {
    let scrollPosition = this.getScrollPosition(e);
    if (scrollPosition > 900) {
      this.panelElRef.nativeElement.style.visibility = 'visible';
    } else {
      this.panelElRef.nativeElement.style.visibility = 'hidden';
    }
  }

  getScrollPosition(e: Event): number {
    return scrollY;
  }

  toTopClick() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

}
